
import React, { Fragment } from 'react';
import { Container, Row, Col, Button, Form, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useRef, useEffect, useState } from "react";

import authService from "../services/auth.service";

const ResetPassword = () => {

   const [msg, setMsg] = useState("");
   const [resetMsg, setResetMsg] = useState("");
   const [isResetting, setIsResetting] = useState(false);
   const navigate = useNavigate();
   const [searchParams] = useSearchParams();
   const token = searchParams.get("token");
   const username = searchParams.get("username");

   const {
      register,
      handleSubmit,
      formState: { errors },
      watch,
   } = useForm();

   const password = useRef({});
   password.current = watch("password", "");

   useEffect(() => {
      authService
        .checkToken(token, username)
        .then(({ data }) => setResetMsg(data.message))
        .catch((e) => console.error(e.response));
    }, [token, username]);

    const handlePasswordReset = (data) => {
      setIsResetting(true);
      authService
        .resetPassword(token, username, data.password, data.password2)
        .then(({ data }) => {
         console.log("Reset response: ", data)
          if (data.status === "error") {
            setIsResetting(false);
            setResetMsg(data.msg);
            return;
          }
         setResetMsg("Your password was reset successfully!");
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        })
        .catch((err) => {
          setIsResetting(false);
        });
    };

    return (
         <Fragment>   
            <Container className="p-5 rounded-lg m-5">
               <Row>
               <Col className="col-12 d-flex flex-column justify-content-center align-items-center bg-dark text-white p-5" >
                  <h3>
                    Reset Password
                  </h3>
                  
                  <Form onSubmit={handleSubmit(handlePasswordReset)}>

                     <Form.Group className="mb-3" controlId="formPassword">
                        <Form.Text className="text-muted">
                           Password must be 8-20 characters long, must include lower, upper, number, and special chars !@#$%&*
                        </Form.Text>
                        <Form.Control type="password" placeholder="Password" 
                           {...register("password", {
                              minLength: {
                                 value: 8,
                                 message: "Password must have at least 8 characters",
                               },
                              required: "Password is required",
                              validate: (value) => {
                                 return (
                                   [/[a-z]/, /[A-Z]/, /[0-9]/, /[!@#$%&*]/].every((pattern) =>
                                     pattern.test(value)
                                   ) || "must include lower, upper, number, and special chars"
                                 );
                               },
                              
                            })}
                        />
                        {errors.password && (
                           <Form.Text className="text-danger">
                           {errors.password.message}
                           </Form.Text>
                           )} 
                     </Form.Group>

                     <Form.Group className="mb-3" controlId="formPassword2">
                        
                        <Form.Control type="password" placeholder="Confirm Password" 
                           {...register("password2", {
                              validate: (value) => value === password.current || "Passwords do not match",
                              
                            })}
                        />
                        {errors.password && (
                           <Form.Text className="text-danger">
                           {errors.password2.message}
                           </Form.Text>
                           )} 
                     </Form.Group>

                     <Form.Group>
                        <Button variant="primary" type="submit" disabled={isResetting}>
                           {isResetting ? <Spinner /> : "Reset Password"}
                        </Button>  
                        {resetMsg && (
                           <Form.Text className="text-danger">
                           {resetMsg}
                           </Form.Text>
                        )}  
                     </Form.Group>
                    
                  </Form>
                  
                  
               </Col>
               </Row>
            </Container>
         </Fragment>

    );
  


};

export default ResetPassword;
